import styled from 'styled-components';

export default {
	Preview : styled.div`
		padding: 10px;
        white-space:pre-wrap;
	`,
	ExplanationWrapper : styled.div`

	`,
	ExplanationTitle : styled.h5`
	`,
	Explanation : styled.div`
		padding: 10px;
		white-space:pre-wrap;
	`
};